export default "__VITE_ASSET__NDjcfEKx__"